module.exports = __webpack_public_path__ + "static/media/vicki.8ba07968.jpg";